export default function ResearchToReality() {
  const steps = [
    {
      number: '01',
      title: 'Research',
      description:
        'We studied existing governance frameworks, consulted with Indigenous communities across Aotearoa and beyond, and mapped the gap between what decentralised tech promises and what communities actually need.',
    },
    {
      number: '02',
      title: 'Design',
      description:
        'From that research, we co-designed a governance architecture built on tikanga — not bolted on as an afterthought. The three-house model, token economy, and contribution system all emerged from this process.',
    },
    {
      number: '03',
      title: 'Development',
      description:
        'We have started building it. The Matou infrastructure, community platform, and governance tooling are live and in use in our own community experiments providing fully self hosted communications and membership systems, with a clear path toward full digital sovereignty.',
    },
  ];

  return (
    <div id="journey" className="mt-12 md:mt-16" style={{ scrollMarginTop: '5rem' }}>
      <div className="max-w-4xl mx-auto text-center mb-16">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-matou-teal-dark mb-4">
          How We Got Here
        </h2>
        <p className="font-mono text-sm md:text-base text-matou-text-muted leading-relaxed">
          Since 2022, Mātou Collective has been working at the intersection of
          Indigenous governance and building decentralised systems
          grounded in Indigenous knowledge. What started as an exploration journey
          has grown into a migration plan to our own digital lands where our
          communities will be safe and can thrive.
        </p>
      </div>

      {/* Timeline Steps */}
      <div className="max-w-4xl mx-auto relative grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-0">
        {/* Horizontal connector line (desktop only) */}
        <div
          className="hidden md:block absolute top-5 left-0 right-0 h-px bg-matou-teal-soft"
          aria-hidden="true"
        />

        {/* Vertical connector line (mobile only) */}
        <div
          className="md:hidden absolute top-0 bottom-0 left-5 w-px bg-matou-teal-soft"
          aria-hidden="true"
        />

        {steps.map((step) => (
          <div key={step.number} className="relative flex md:flex-col items-start gap-5 md:gap-0 md:px-6">
            {/* Step circle */}
            <div className="relative z-10 flex-shrink-0 w-10 h-10 rounded-full bg-matou-teal-medium flex items-center justify-center">
              <span className="font-mono text-xs font-bold text-white">
                {step.number}
              </span>
            </div>

            {/* Text content */}
            <div className="md:mt-6">
              <h3 className="font-heading text-xl font-bold text-matou-teal-dark mb-3">
                {step.title}
              </h3>
              <p className="font-mono text-sm text-matou-text-muted leading-relaxed">
                {step.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-12">
        <a
          href="https://docs.matou.nz/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-8 py-3 border-2 border-matou-teal-dark text-matou-teal-dark font-mono text-sm font-semibold rounded-lg hover:bg-matou-teal-dark hover:text-white transition-colors"
        >
          To learn more about our work visit our docs
        </a>
      </div>
    </div>
  );
}
